import { render } from "./delaervatreport.vue?vue&type=template&id=89835b80"
import script from "./delaervatreport.vue?vue&type=script&lang=js"
export * from "./delaervatreport.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__